const WORKSPACE_ENTERED_KEY = "multi-chat:workspace-entered";
const FRESH_AUTH_KEY = "multi-chat:fresh-auth-pending";

/** True after the person chose a workspace in this browser session. */
export function hasEnteredWorkspace(): boolean {
  try {
    return window.sessionStorage.getItem(WORKSPACE_ENTERED_KEY) === "true";
  } catch {
    return false;
  }
}

export function markWorkspaceEntered(): void {
  try {
    window.sessionStorage.setItem(WORKSPACE_ENTERED_KEY, "true");
    window.sessionStorage.removeItem(FRESH_AUTH_KEY);
  } catch {
    // Private browsing can reject sessionStorage.
  }
}

export function clearWorkspaceEntered(): void {
  try {
    window.sessionStorage.removeItem(WORKSPACE_ENTERED_KEY);
  } catch {
    // Ignore storage failures on logout.
  }
}

/** Fresh Google sign-in must show the chooser even if a previous org id is stored. */
export function markFreshAuthentication(): void {
  try {
    window.sessionStorage.setItem(FRESH_AUTH_KEY, "true");
    window.sessionStorage.removeItem(WORKSPACE_ENTERED_KEY);
  } catch {
    // Private browsing can reject sessionStorage.
  }
}

export function isFreshAuthentication(): boolean {
  try {
    return window.sessionStorage.getItem(FRESH_AUTH_KEY) === "true";
  } catch {
    return false;
  }
}

export function clearFreshAuthentication(): void {
  try {
    window.sessionStorage.removeItem(FRESH_AUTH_KEY);
  } catch {
    // Ignore storage failures.
  }
}
